import { ReactNode } from "react"

import { Analytics } from "utils/analytics"
import { DescriptionOverlay } from "components/Footer/components/DescriptionOverlay"

export interface SocialNetwork {
    link: string
    className: string
    name: string
    overlay?: ReactNode
}

const instagramLink = "https://www.instagram.com/psyalter.ru/"
const facebookLink = "https://www.facebook.com/psyalter/"
const defaultClassName = "footer__social-network-wrapper footer__social-network-indent"
const metaDescription = (
    <>
        * Meta Platforms Inc. (соц. сети Facebook, Instagram) признана экстремистской,
        ее&nbsp;деятельность запрещена на&nbsp;территории России.
    </>
)

export const socialNetworks: SocialNetwork[] = [
    {
        className: defaultClassName,
        name: "Telegram",
        link: "https://t.me/psyalter_ru",
    },
    {
        className: defaultClassName,
        name: "VK",
        link: "https://vk.com/psyalter",
    },
    {
        className: defaultClassName,
        name: "Twitter",
        link: "https://twitter.com/psyalter",
    },
    {
        className: "footer__social-network-wrapper footer__meta-indent",
        name: "Instagram",
        link: instagramLink,
        overlay: (
            <div className="support-tooltip">
                <a
                    onClick={() =>
                        Analytics.user_followed_the_link_to_social_network({
                            socialNetwork: "Instagram",
                        })
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    href={instagramLink}
                    className="footer__social-network-wrapper"
                >
                    <span className="footer__social-network support-tooltip__headline">
                        Instagram
                    </span>
                    *
                </a>
                <div>{metaDescription}</div>
            </div>
        ),
    },
    {
        className: "footer__social-network-wrapper footer__social-network-indent",
        name: "Facebook",
        link: facebookLink,
        overlay: (
            <div className="support-tooltip">
                <a
                    onClick={() =>
                        Analytics.user_followed_the_link_to_social_network({
                            socialNetwork: "Facebook",
                        })
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    href={facebookLink}
                    className="footer__social-network-wrapper"
                >
                    <span className="footer__social-network support-tooltip__headline">
                        Facebook
                    </span>
                    *
                </a>
                <div>{metaDescription}</div>
            </div>
        ),
    },
]

export function SocialNetworksLinks() {
    return (
        <div className="footer__social-networks">
            {socialNetworks.map((network) => (
                <DescriptionOverlay key={network.name} network={network} />
            ))}
        </div>
    )
}
